<template>
  <section class="legal-page container-fluid">
    <div class="legal-header">
      <h1 class="title">{{ title }}</h1>
      <p v-if="lastUpdated" class="last-updated">Last updated: {{ lastUpdated }}</p>
    </div>
    <div class="legal-content container">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "LegalPage",
  props: {
    title: {
      type: String,
      required: true,
    },
    lastUpdated: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.legal-page {
  padding-bottom: 80px;

  .legal-header {
    background: #edebeb;
    padding: 60px 40px;
    margin-bottom: 60px;

    .title {
      font-size: 60px;
      font-weight: 600;
      color: #000;
      margin: 0;

      @media (max-width: 768px) {
        font-size: 36px;
      }
    }

    .last-updated {
      margin: 12px 0 0;
      font-size: 14px;
      color: #666;
    }

    @media (max-width: 768px) {
      padding: 40px 20px;
      margin-bottom: 40px;
    }
  }

  .legal-content {
    max-width: 900px;

    :deep(h2) {
      font-size: 26px;
      font-weight: 600;
      color: #000;
      margin: 40px 0 16px;

      @media (max-width: 768px) {
        font-size: 22px;
        margin: 32px 0 12px;
      }
    }

    :deep(h3) {
      font-size: 18px;
      font-weight: 600;
      color: #000;
      margin: 24px 0 10px;
    }

    :deep(p),
    :deep(li) {
      font-size: 16px;
      line-height: 1.7;
      color: #555;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }

    :deep(p) {
      margin-bottom: 16px;
    }

    :deep(ul),
    :deep(ol) {
      margin: 0 0 20px;
      padding-left: 22px;

      li {
        margin-bottom: 8px;
      }
    }

    :deep(a) {
      color: #ff6b6b;
      text-decoration: none;

      &:hover {
        opacity: 0.8;
      }
    }

    :deep(.highlight-box) {
      background: #fff5f5;
      border-left: 4px solid #ff6b6b;
      padding: 20px 24px;
      border-radius: 8px;
      margin: 24px 0;

      p:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
